import Vue from 'vue';
import Vuex from 'vuex';
// import VuexEasyFirestore from 'vuex-easy-firestore';
import fb from '../firebaseConfig';
import router from '../router';

// Import Modules
// import auth from './auth';
// import contextModule from './database/easyFirestore/context';
// import pagesModules from './database/easyFirestore/pages';
// import invitesModule from './database/easyFirestore/invites';
// import views from './views/index';
// import components from './components/index';
// import track from './database/analytics';

import useUserSummary from './useUserSummary';

import { getAuth, onAuthStateChanged } from "firebase/auth";
// add vuex to vue
Vue.use(Vuex);

// do the magic 🧙🏻‍
// const easyFirestore = VuexEasyFirestore([contextModule, pagesModules, invitesModule], {
//   logging: true,
//   FirebaseDependency: fb.firebase
// });

const storeData = {
  // plugins: [easyFirestore],
  modules: {
    // auth,
    // views,
    // components,
    // track,
    // context: contextModule,
    // pages: pagesModules,
    // invites: invitesModule
  }
};
const store = new Vuex.Store(storeData);
// const authent = getAuth();
// onAuthStateChanged(authent, async user => {
//   console.log('auth changed');
//   if (user) {
//     store.commit('auth/setCurrentUser', user);
//     store.commit('auth/setFetchingUserData', true);
//     useUserSummary()
//       .subscribe()
//       .catch(e => console.log(e));
//     try {
//       await store.dispatch('auth/subscribeToUser');
//       store.commit('auth/setFetchingUserData', false);
//     } catch (e) {
//       console.log(e);
//       store.commit('auth/setFetchingUserData', false);
//     }
//   } else {
//     //store.dispatch('userContextsLite/unsubscribeToUserContextsLite');
//     useUserSummary().unsubscribe;
//   }
// });

export default store;
